var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('media-image',{attrs:{"height":_vm.height,"resolution":_vm.resolution,"no-cache":_vm.noCache,"file-path":_vm.filePath},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }